import { useApiStore } from "@/stores/api/index.ts";
import getDefaultOpts from "@/store/utils/getDefaultOpts.js";
import { updateCategoryMedia } from "@/util/patchMediaHelpers.js";

function updateStore({ commit }, subCategoryIndex, category, patch) {
  const newCategory = { ...category };
  Object.keys(patch).forEach((key) => {
    newCategory.categories[subCategoryIndex][key] = patch[key];
  });
  commit("storeCategory", newCategory);
}

const patchSubCategory = async (
  module,
  { parentCategoryID, path, patch, opts = {} }
) => {
  const api = useApiStore();
  const { getters, dispatch } = module;
  const config = Object.assign(getDefaultOpts(), opts);
  const category = getters.category(parentCategoryID);
  const subCategory = category.categories.find((item) => item.path === path);
  const subCategoryIndex = category.categories.findIndex(
    (item) => item.path === path
  );
  const id = subCategory.path.split("/")[2];
  if (config.updateStoreFirst) {
    updateStore(module, subCategoryIndex, category, patch);
  }
  await dispatch("httpRequest", {
    func: api.patchCategory(id, updateCategoryMedia(patch)),
    config,
  });
  if (!config.updateStoreFirst) {
    updateStore(module, subCategoryIndex, category, patch);
  }
};

export { patchSubCategory };
